import type { useTranslations } from 'next-intl';

type Translate = ReturnType<typeof useTranslations<'auth.resetPassword'>>;

export function getNewPasswordErrorMessage(t: Translate, code: string | undefined) {
  if (!code) return undefined;
  const map: Record<string, string> = {
    required: t('errors.new_password.required'),
    too_short: t('errors.new_password.too_short'),
    too_long: t('errors.new_password.too_long'),
    missing_uppercase: t('errors.new_password.missing_uppercase'),
    missing_digit: t('errors.new_password.missing_digit'),
    missing_special: t('errors.new_password.missing_special'),
  };
  return map[code] ?? code;
}

export function getConfirmPasswordErrorMessage(t: Translate, code: string | undefined) {
  if (!code) return undefined;
  const map: Record<string, string> = {
    required: t('errors.confirm_password.required'),
    mismatch: t('errors.confirm_password.mismatch'),
  };
  return map[code] ?? code;
}

export function getResetApiErrorMessage(t: Translate, code: string): string {
  switch (code) {
    case 'validation':
      return t('errors.api.validation');
    case 'rate_limited':
      return t('errors.api.rate_limited');
    default:
      return t('errors.api.server_error');
  }
}
